<template>
  <div class="view view-home inner-width">
    <section>
      <article>
        <img :src="`${ image.secure_url }`" alt="">
        <div v-html="bodyHtml"></div>
      </article>
      <aside>
        <ComponentProductsList :links="links" />
      </aside>
      <section class="news">
        <div v-for="n in news" :key="n.id"  class="news-item">
          <h2>{{ n.fields.title.text }}</h2>
          <div v-html="n.fields.body.content" />
        </div>
      </section>
    </section>
  </div>
</template>


<script>
import { baseCmsUrl, baseCmsNode } from '../../config';
import ComponentProductsList from '@/components/ComponentProductsList.vue';

export default {
  name: 'home',
  components: {
    ComponentProductsList
  },
  data() { 
    return {
      bodyHtml: '',
      image: '',
      links: [],
      news: []
    }
  },
  mounted() {
    this.$http.get(`${baseCmsUrl}layout/path/${baseCmsNode}hjem`).then((response) => {
      this.links = response.data.main[0].collection_items;
      this.image = response.data.main[1].content.fields.image;
      this.bodyHtml = response.data.main[1].content.fields.body.content;
      this.news = response.data.main[2].collection_items;
      return;
    });
    
  }
}
</script>
